import { createReducer } from "redux-act";
import { IndexedDBCache, Tracker } from "finhelper";

import * as actions from "#app/store/actions/auth";

let user = {
    data: {},
    auth: false,
    showLoginModal: false,
    showRegisterModal: false,
    showForgotModal: false,
    avatar: process.env.REACT_APP_API_URL + "/images/avatar/default.svg",
};

const handleGetUser = (state, response) => {
    if (typeof response === "object" && response.result === "success") {
        return {
            ...state,
            data: response.data,
            auth: true,
        };
    } else {
        return state;
    }
};

const handleLogout = (state) => {
    localStorage.clear();
    IndexedDBCache.clearAll();

    return {
        ...state,
        data: {},
        auth: false,
    };
};

const handleLoginModal = (state) => {
    return {
        ...state,
        showLoginModal: true,
        showRegisterModal: false,
        showForgotModal: false,
    };
};

const handleForgotModal = (state) => {
    return {
        ...state,
        showForgotModal: true,
        showLoginModal: false,
        showRegisterModal: false,
    };
};

const handleRegisterModal = (state) => {
    Tracker.reachGoal("register_click", {
        // //user_id: this.props.Client ? this.props.Client.id : null
    });

    return {
        ...state,
        showRegisterModal: true,
        showForgotModal: false,
        showLoginModal: false,
    };
};

const handleCloseModal = (state) => {
    return {
        ...state,
        showLoginModal: false,
        showRegisterModal: false,
        showForgotModal: false,
    };
};

const reducer = createReducer(
    {
        [actions.handleGetUser]: handleGetUser,
        [actions.handleLogout]: handleLogout,
        [actions.handleLoginModal]: handleLoginModal,
        [actions.handleForgotModal]: handleForgotModal,
        [actions.handleRegisterModal]: handleRegisterModal,
        [actions.handleCloseModal]: handleCloseModal,
    },
    user
);

export default reducer;
